<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card>
              <v-card-title class="pb-5">
                <v-btn @click="addDiscount" class="submit-btn">
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  ذخیره
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      :rules="rules.title"
                      v-model="title"
                      :error-messages="errors.caption"
                      label="عنوان"
                      required
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <price-input
                      :dense="true"
                      :label="'سقف استفاده'"
                      v-model="price_max"
                    ></price-input>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="point"
                      :error-messages="errors.point"
                      type="number"
                      label="امتیاز"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="discount"
                      :error-messages="errors.discount"
                      type="number"
                      label="درصد"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="usable"
                      type="number"
                      label="دفعات قابل استفاده"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                      v-model="service"
                      :rules="rules.service"
                      :items="services"
                      item-text="title"
                      item-value="id"
                      label="انتخاب پنل"
                      :error-messages="errors.service_id"
                      outlined
                      multiple
                      dense
                    ></v-select>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                      disabled
                      v-model="target"
                      :items="owners"
                      item-text="name"
                      :error-messages="errors.own_number"
                      item-value="id"
                      label="انتخاب هدف"
                      outlined
                      dense
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                      v-model="show"
                      :items="shows"
                      item-text="name"
                      item-value="id"
                      :error-messages="errors.show"
                      label="وضعیت"
                      outlined
                      dense
                    ></v-select>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-radio-group v-model="row" row>
                      <v-radio label="کد پویا" value="acceptable"></v-radio>
                      <v-radio label="کد ایستا" value="direct"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      :disabled="row === 'acceptable'"
                      :error-messages="errors.code"
                      v-model="code"
                      label="کد تخفیف دستی"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <date-picker
                      v-model="expired_at"
                      label="تاریخ انقضا"
                      format="YYYY-MM-DD HH:mm"
                      type="datetime"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      dense
                    >
                    </date-picker>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex class="p-2">
                    <ckeditor
                      :editor="editor.editor"
                      v-model="description"
                      :config="editor.editorConfig"
                    ></ckeditor>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SET_BREADCRUMB } from "../../../../core/services/store/breadcrumbs.module";
import smsTariffPicker from "@/view/pages/pickers/smsTariffPicker";
import priceInput from "@/view/pages/pickers/priceInput";
import subLinePicker from "@/view/pages/pickers/subLinePicker";
import permissionPicker from "@/view/pages/pickers/permissionPicker";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import userPicker from "@/view/pages/pickers/userPicker";

export default {
  components: { userPicker, priceInput },
  props: ["id"],
  data() {
    return {
      loading: false,
      service: [],
      services: [],
      users: [],
      title: "",
      row: "acceptable",
      picture: null,
      code: null,
      target: null,
      price_max: 0,
      expire: null,
      usable: 0,
      permissions: {},
      roleid: null,
      point: null,
      discount: null,
      expired_at: null,
      tariff: {},
      subline: {},
      tariffs: [],
      owner: { id: null },
      owners: [
        { id: "all", name: "همه کاربران" },
        { id: "selectable", name: "انتخاب دستی کاربر" },
        { id: "pack", name: "پنل" },
        { id: "product", name: "محصول" },
      ],
      show: { id: null },
      shows: [
        { id: "pending", name: "در حال انتظار" },
        { id: "public", name: "قابل استفاده" },
        { id: "finished", name: "تمام شده" },
      ],
      sortOrder: null,
      features: [],
      description: null,
      roles: [],
      errors: [],
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      rules: {
        title: [
          (val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد.",
        ],
        services: [(val) => val.length > 0 || "فیلد سرویس الزامی می باشد."],
        price: [(val) => (val || "").length > 0 || "فیلد قیمت الزامی می باشد."],
        expire: [
          (val) => (val || "").length > 0 || "فیلد تاریخ انقضا الزامی می باشد.",
        ],
      },
    };
  },
  mounted() {
    this.getPacks();
    this.getDiscountInfo();
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
  methods: {
    getDiscountInfo() {
      this.requestApiGet(`admin/discount/show/${this.id}`).then(({ data }) => {
        this.title = data.caption;
        this.expired_at = data.expired_at;
        this.point = data.point;
        this.type = data.type;
        this.price_max = data.price_max;
        this.code = data.code;
        this.discount = data.discount;
        this.users = data.users;
        this.title = data.caption;
        this.usable = data.usable;
        this.target = data.target;
        this.status = data.status;
        this.description = data.description;
        this.service = data.pack_id;
        this.show = data.status;
        this.row = "direct";
        this.code = data.queries?.code;

        // this.data = data.data;
        // caption: this.title,
        //     price_max: this.price_max.toString().replace(/,/g, ''),
        //     expired_at: this.expired_at,
        //     point: this.point,
        //     type: this.row,
        //     code: this.code,
        //     discount: this.discount,
        //     users: this.users,
        //     usable: this.usable,
        //     target: this.target,
        //     status: this.show,
        //     description: this.description,
        //     pack_id: this.service,
      });
    },

    getPacks() {
      this.requestApiGet("pack?length=10000").then(({ data }) => {
        this.services = data.data;
      });
    },
    addDiscount() {
      this.loading = true;
      this.requestApiPost(`admin/discount/update/${this.id}`, {
        caption: this.title,
        price_max: this.price_max.toString().replace(/,/g, ""),
        expired_at: this.expired_at,
        point: this.point,
        type: this.row,
        code: this.code,
        discount: this.discount,
        users: this.users,
        usable: this.usable,
        target: this.target,
        status: this.show,
        description: this.description,
        pack_id: this.service,
      })
        .then((response) => {
          this.$toast.success("تخفیف  با موفقیت ویرایش شد.");
          this.$router.push({ name: "adminDiscounts.index" });
        })
        .catch(({ response }) => {
          this.errors = response;
        });
      this.loading = false;
    },
    setEdited(x) {
      x.edited = true;
    },
    createRegister() {
      this.register.push({
        organName: "",
        type: null,
        date: "",
      });
    },
    addCount() {
      this.features.push({
        id: this.features.length + 1,
        key: null,
        value: null,
      });
    },
    decreaseCount() {
      if (this.features.length > 0) {
        this.features.pop();
      }
    },

    getTariff() {
      this.requestApiGet("tariff").then(({ data }) => {
        this.tariffs = data.data;
      });
    },

    getRoles() {
      this.requestApiGet("admin/roles").then((response) => {
        this.roles = response.data.data;
      });
    },
  },

  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters("PermissionsIndex", ["data", "total", "loading"]),

    config() {
      return this.layoutConfig();
    },
  },
  watch: {
    query: {
      handler(query) {
        this.setQuery(query);
        this.fetchIndexData();
      },
      deep: true,
    },
  },
};
</script>
